import _ from 'lodash';

export default{
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: null,
    config: null,
    name: String
  },
  data: data,
  mounted: mounted,
  watch:{
    $config: {
      handler: $configWatch,
      deep: true
    },
    value: $valueWatch
  },
  computed: {
    $config: $config,
    selectElement: selectElement,
    $$config: $$config
  },
  methods: {
    selection: selection
  },
  destroyed: destroyed
}

function data(){
  return{
    triggeredByClick: null
  }
}

function mounted(){
  let scope = this;

  scope.$nextTick(() => {
    scope.selectElement.select2(scope.$$config).on('change', onChange);
    if(scope.$$config.data && scope.$$config.data.length === 0) return;
    scope.selectElement.val(scope.value).trigger('change.select2');

    function onChange(){
      let data = scope.selectElement.select2('data');
      let selection = scope.selection(data);
      scope.$emit('change', selection.value, selection.option);
    }
  });
}

function $configWatch(){
  this.$nextTick(() => {
    let select2 = this.selectElement.empty().select2(this.$$config);
    select2.val(this.value).trigger('change');
  });
}

function $valueWatch(newValue){
  this.triggeredByClick = false;
  this.selectElement.val(newValue).trigger('change');
  this.triggeredByClick = null;
}

function $config(){}

function destroyed(){
  this.selectElement.off().select2('destroy');
}

function selectElement(){
  return $(this.$el).find('select');
}

function $$config(){
  return _.assign({dropdownParent: $(this.$el)}, this.$config);
}

function selection(){}